import { BaseCreateComponent } from "../../BaseCreateComponent";
import { BasePageComponent } from "../../pages/BasePageComponent";
import { BaseAsideMenuComponent } from "./BaseAsideMenuComponent";
import { ConfirmDialogComponent } from "../../ConfirmDialogComponent";
import template from "./template.html";

export interface AppData {
  brand: string;
  title: string;
  usuario: string;
  onLogout: () => void;
  asideMenuComponentHandler: () => BaseAsideMenuComponent;
  pages: (appRoute: string) => BasePageComponent | null;
}

const menuShowCssClass: string = "menu-show";
const menuCollapseCssClass: string = "menu-collapse";

export class AppComponent extends BaseCreateComponent<HTMLDivElement> {
  private _data: AppData;
  //
  private _asideMenuComponent!: BaseAsideMenuComponent;
  private _currentPage: BasePageComponent | null = null;

  constructor(data: AppData) {
    super();
    //
    this._data = data;
  }

  //

  public setTitle(title: string) {
    document.getElementById("topbarTitle")!.innerHTML = title;
  }

  public clearTitle() {
    document.getElementById("topbarTitle")!.innerHTML = this._data.title;
  }

  //

  protected getTagName(): string {
    return "div";
  }

  protected getElementId(): string {
    return "app";
  }

  protected override afterInit(element: HTMLDivElement): void {
    element.classList.add("sx-app");
    element.innerHTML = this.createHtmlString(template, this._data);
    //
    window.addEventListener("resize", this._fx_onWindowResize);
    this._fx_initSignOut(element);
    this._fx_initToggleMenu(element);
    this._asideMenuComponent = this._data.asideMenuComponentHandler();
    this._asideMenuComponent.setOnPageChange((page: string) => {
      page = page.replace(window.origin, "");
      this._fx_hideMenu();
      this._navigateTo(page);
    });
    this._asideMenuComponent.init();
    document.addEventListener("app:navigate", (e) => {
      this._navigateTo((e as CustomEvent<string>).detail);
    });
  }

  protected override beforeDispose(_element: HTMLDivElement): void {
    window.removeEventListener("resize", this._fx_onWindowResize);
  }

  //

  private _fx_hideMenu(): void {
    const sidebarWrapper = document.getElementById("sidebarWrapper")!;
    sidebarWrapper.classList.remove(menuShowCssClass);
    sidebarWrapper.classList.add(menuCollapseCssClass);
  }

  private _fx_initToggleMenu(element: HTMLDivElement): void {
    const sidebarWrapper = document.getElementById("sidebarWrapper")!;

    const showMenu = () => {
      sidebarWrapper.classList.remove(menuCollapseCssClass);
      sidebarWrapper.classList.add(menuShowCssClass);
    };

    element.querySelector<HTMLButtonElement>(".sx-main .toggle-menu")
      ?.addEventListener("click", showMenu);

    element.querySelector<HTMLButtonElement>(".sx-sidebar .toggle-menu")
      ?.addEventListener("click", () => this._fx_hideMenu());

    element.querySelector<HTMLElement>(".sx-sidebar-wrapper.toggle-menu")
      ?.addEventListener("click", () => this._fx_hideMenu());
  }

  private _fx_onWindowResize = () => {
    const windowWidth: number = window.innerWidth;
    const fx_removeCssClass = (element: HTMLElement) => {
      element.classList.remove(menuCollapseCssClass);
      element.classList.remove(menuShowCssClass);
    };
    setTimeout(() => {
      if (windowWidth == window.innerWidth) {
        fx_removeCssClass(document.getElementById(this.getElementId())!);
        fx_removeCssClass(document.getElementById("sidebarWrapper")!);
      }
    }, 100);
  };

  private _fx_initSignOut(element: HTMLDivElement) {
    element.querySelectorAll<HTMLElement>(".sign-out").forEach((element) => {
      element.onclick = () => {
        new ConfirmDialogComponent({
          title: "Cerrar sesión",
          message: "¿Desea cerrar la sesión?",
          confirmLabel: "Cerrar sesión",
          cancelLabel: "Cancelar",
          onConfirm: () => this._data.onLogout(),
        }).init();
      };
    });
  }

  /**
   * Abre la pantalla de la ruta, venga del menú o de una página (`app:navigate`): cierra la anterior, pone el título y
   * marca la opción en el menú. Si el rol no puede abrir la ruta, no hace nada y el menú queda como estaba.
   */
  private _navigateTo(appRoute: string): void {
    const page = this._data.pages(appRoute);
    if (!page) {
      return;
    }
    //
    if (this._currentPage) {
      this._currentPage.dispose();
    }
    this._currentPage = page;
    //
    if (page.getPageTitle()) {
      this.setTitle(page.getPageTitle() ?? this._data.title);
    } else {
      this.clearTitle();
    }
    this._asideMenuComponent.marcarRuta(appRoute);
    //
    page.init();
  }

  //
}
